import React from 'react';
import classNames from 'classnames';

import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import { SOCIAL_LOGINS } from 'rebook/apps/users/constants';
import mainStyles from 'rebook/apps/users/views/UserSettingsView/style.scss';

import styles from './style.scss';


const getAccountBindingStatus = (provider, socialAuth) => {
  if (!socialAuth) {
    return false;
  }
  const bindedAccount = socialAuth.filter((item) => item.provider === provider);
  return bindedAccount && bindedAccount.length > 0;
};

const SociaAccountItem = ({ item, socialAuth, showLoader, unbindSocialNetwork }) => {
  const isBound = getAccountBindingStatus(item.provider, socialAuth);
  return (
    <li className={classNames(styles.item, `jest-social-auth-${item.slug}`)}>
      {isBound && !showLoader && (
        <a className={classNames(styles.socialNetwork, `theme-${item.slug}`)}
          onClick={(e) => { unbindSocialNetwork(e, item.provider); }}>
          <span className={styles.socialNetworkIcon}>{item.icon}</span>
          <span className={styles.socialNetworkIsUnboundStatus}>
            Отключить
          </span>
        </a>
      )}
      {isBound && showLoader && (
        <a className={classNames(styles.socialNetwork, `theme-${item.slug}`)}>
          <span className={styles.socialNetworkIcon}>{item.icon}</span>
          <span>
            <SpinnerLoader theme="light" width={'16px'} height={'16px'} />
          </span>
        </a>
      )}
      {!isBound && (
        <a className={classNames(styles.socialNetwork, `theme-${item.slug}`)}
          href={`${item.url}?next=/account/edit/`}>
          <span className={styles.socialNetworkIcon}>{item.icon}</span>
          <span className={styles.socialNetworkStatus}>Подключить</span>
        </a>
      )}
    </li>
  );
};

const UserSettingsSocialNetworks = ({ user, unbindSocialNetwork, isLoading }) => {
  const { social_auth: socialAuth } = user;
  return (
    <div className={classNames(mainStyles.billetContainer, styles.socialNetworks)}>
      <div className="title-2">Социальные сети</div>
      <div className={styles.socialNetworksDescription}>
        <span>Подключите социальные сети, чтобы входить через них в MyBook</span>
      </div>
      <ul className={styles.items}>
        {Object.keys(SOCIAL_LOGINS).map((key, i) => {
          const item = SOCIAL_LOGINS[key];
          const showLoader = isLoading && user.unboundProvider === item.provider;
          if (item.slug !== 'litres') {
            return (
              <SociaAccountItem
                item={item}
                socialAuth={socialAuth}
                showLoader={showLoader}
                key={`${i}-${item.slug}-${item.id}`}
                unbindSocialNetwork={unbindSocialNetwork} />
            );
          }
        })}
      </ul>
    </div>
  );
};

export default UserSettingsSocialNetworks;
